import template from "./error-404-page.html.twig";

Packlab.Component.register('error-404-page', {
    template
});